import "../../css/footer.css";
import "../../css/container.css";
import "../../css/fonts.css";
import { useNavigate } from "react-router-dom";
export const FooterLinksLocalContact = () => {
  const navigate = useNavigate();

  return (
    <div className="footer-links-local">
      <div
        className={"title-text-font" + " " + " footer-contact-link"}
        onClick={() => navigate("/contact")}
      >
        CONTACT US
      </div>
      <div className="footer-text">Like good NPCs, we're here to listen.</div>
    </div>
  );
};
// textAlign: "center",
